import { parse } from "query-string";
import React from "react";

import BlogPost from "@/mk2/apps/blogs/components/BlogPost/BlogPost";
import { AUTH_KEY_NAME } from "@/mk2/apps/blogs/constants";
import { blogsUrl } from "@/mk2/apps/blogs/urls";
import { Failure } from "@/mk2/components/errors/Failure";
import Complaint from "@/mk2/containers/Complaint/Complaint";
import { ComplaintTargetType } from "@/mk2/containers/Complaint/Complaint.schemas";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { BACK_TO_BLOGS } from "@/mk/autogenerated/translation";

import styles from "./BlogsShortMessageDetail.mscss";
import { Props } from "./BlogsShortMessageDetailPage";

export class BlogsShortMessageDetail extends React.PureComponent<Props> {
    public render() {
        const { loadingState, post } = this.props;

        return (
            <div className={styles.BlogsShortMessageDetail}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderSuccess}
                    onRenderFailure={this.renderFailure}
                    hasData={!!post}
                />
            </div>
        );
    }

    private renderFailure = () => {
        const { errorMessage } = this.props;

        return (
            <Failure
                errorMessage={errorMessage}
                onRetry={this.load}
                backButtonUrl={blogsUrl}
                backButtonLabel={BACK_TO_BLOGS}
            />
        );
    };

    private renderSuccess = () => {
        const {
            post,
            requestUser,
            requestUserPermissions,
            location,
            routeNavigate,
            routePathPattern,
            commentsCount,
            complaintsCount,
            isMobile,
            onIgnoreUser,
            onPostToggleMenuMore,
            onPostToggleVisibilityMenuMore,
            onSetDisplayingAtFeed,
            onReport,
            onSetVisibility,
        } = this.props;

        return (
            <React.Fragment>
                <Complaint
                    id={post.id}
                    entity={ComplaintTargetType.PhotoblogPost}
                    className={styles.BlogsShortMessageDetail__complaint}
                    scrollOffset={44 + 44 + 30 /* header + 30px spacing */}
                    inForum={false}
                    inGroups={post && "group" in post && !!post.group}
                />

                <BlogPost
                    post={post}
                    forceEagerImages
                    isMobile={isMobile}
                    commentsCount={commentsCount}
                    complaintsCount={complaintsCount}
                    requestUser={requestUser}
                    requestUserPermissions={requestUserPermissions}
                    onDelete={this.handleDelete}
                    onIgnoreUser={onIgnoreUser}
                    onReport={onReport}
                    onSetDisplayingAtFeed={onSetDisplayingAtFeed}
                    onSetVisibility={onSetVisibility}
                    onToggleMenuMore={onPostToggleMenuMore}
                    onToggleVisibilityMenuMore={onPostToggleVisibilityMenuMore}
                    isPreloaded
                    location={location}
                    routeNavigate={routeNavigate}
                    routePathPattern={routePathPattern}
                />
            </React.Fragment>
        );
    };

    private handleDelete = (postId) => {
        this.props.onDelete(postId);
    };

    private load = () => {
        const {
            routeParams: { username, postSlug },
            onLoad,
            location,
        } = this.props;
        const q = parse(location.search);

        onLoad(username, postSlug, q[AUTH_KEY_NAME] as string);
    };
}
